import { ActionType, GlobalStateInterface } from "./types";
import { initialState } from "./index";

const Reducer = (
  state: GlobalStateInterface,
  action: ActionType
): GlobalStateInterface => {
  switch (action.type) {
    case "SET_TOAST":
      return {
        ...state,
        toastObject: action.payload,
      };
    case "SET_SIDEBAR_COLLABSE_STATE": {
      return {
        ...state,
        sidebarCollapsed: action.payload,
      };
    }
    case "SET_PERSISTENCE":
      return {
        ...state,
        persistenceType: action.payload,
      };
    case "PURGE_STATE":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
